import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const AltTextDrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 488px;
  height: 100%;

  & * {
    min-height: auto;
    min-width: auto;
  }
`;

export const Section = styled.div<{ fullHeight?: boolean }>`
  padding: ${theme.spacing.large} ${theme.spacing.xLarge};
  height: ${({ fullHeight }) => (fullHeight ? '100%' : 'auto')};
`;

export const Footer = styled.div`
  padding: ${theme.spacing.large} ${theme.spacing.xLarge};
  display: block;
  text-align: right;
  button {
    margin-left: ${theme.spacing.small};
  }
`;

export const Separator = styled.hr`
  height: 1px;
  background: ${theme.color.designSystem.blackOpacity12};
  margin: 0;
  box-shadow: none;
  border: none;
`;

export const Heading = styled.h2`
  font-size: ${theme.font.size.headline};
  line-height: ${theme.font.lineHeight.headline};
  margin: 0;
  padding: 0;
`;

export const SubHeading = styled.h2`
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight.copy};
  margin: 0;
  padding: 0;
`;

export const Text = styled.p`
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};
  margin: 0;
  padding: 0;
`;

export const CharacterCount = styled.small`
  text-align: right;
  font-size: ${theme.font.size.small};
  margin-bottom: 20px;
  display: block;
  width: 100%;
  color: ${theme.color.designSystem.blackOpacity60};
`;
